import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column align-center justify-center h-100",
  style: {"flex":"1"}
}
const _hoisted_2 = {
  key: 0,
  class: "w-100 h-100 px-1",
  style: {"height":"auto"}
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex flex-grow-1 justify-center align-center"
}
const _hoisted_4 = { class: "d-flex flex-column align-center h-100" }
const _hoisted_5 = {
  class: "d-flex justify-center align-center w-100 flex-grow-1",
  style: {"gap":"5px","flex-wrap":"wrap","padding":"auto"}
}
const _hoisted_6 = { style: {"font-size":"6vh","margin-bottom":"5px"} }
const _hoisted_7 = { style: {"font-size":"3vh"} }
const _hoisted_8 = { style: {"font-size":"3vh"} }

import { nextTick, onMounted, ref, watch } from "vue";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Chart } from "chart.js/auto";


export default /*@__PURE__*/_defineComponent({
  __name: 'ForecastPanel',
  props: {
    dadosClima: {},
    chartData: {},
    chartLabels: {}
  },
  setup(__props: any) {

const props = __props;

const isCanvasReady = ref(false);
const window = ref(0);
const length = ref(2);

let chart: Chart | null = null;

onMounted(() => {
  const time = 10000;

  setInterval(() => {
    if (length.value > 0) {
      next();
    }
  }, time);
});

function next() {
  window.value = window.value + 1 > length.value - 1 ? 0 : window.value + 1;
}

watch(
  [() => props.chartData, () => props.chartLabels],
  () => {
    if (props.chartData.length === 0 || props.chartLabels.length === 0) return;

    initializeChart();
    isCanvasReady.value = true;
  },
  { once: true, deep: true }
);

function getWeatherEmoji(iconCode: string) {
  const emojiMap: { [key: string]: string } = {
    "01d": "☀️",
    "01n": "🌙",
    "02d": "⛅",
    "02n": "☁️",
    "03d": "☁️",
    "03n": "☁️",
    "04d": "☁️",
    "04n": "☁️",
    "09d": "🌧️",
    "09n": "🌧️",
    "10d": "🌦️",
    "10n": "🌧️",
    "11d": "⛈️",
    "11n": "⛈️",
    "13d": "❄️",
    "13n": "❄️",
    "50d": "🌫️",
    "50n": "🌫️",
  };
  return emojiMap[iconCode] || "❓";
}

function getNextFiveDays() {
  const daysOfWeek = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
  const today = new Date();
  const nextFiveDays = [];

  for (let i = 1; i <= 5; i++) {
    const futureDate = new Date(today);
    futureDate.setDate(today.getDate() + i);
    nextFiveDays.push(daysOfWeek[futureDate.getDay()]);
  }

  return nextFiveDays;
}

async function initializeChart() {
  await nextTick();

  const canvas = document.getElementById("graficoTempo") as HTMLCanvasElement;
  if (!canvas) {
    console.warn("Canvas com ID 'graficoTempo' não encontrado.");
    return;
  }

  const ctx = canvas.getContext("2d");

  let minValue = 0;
  let maxValue = 0;

  if (props.chartData && props.chartData.length > 0) {
    minValue = Math.min(...props.chartData);
    maxValue = Math.max(...props.chartData);
  }

  chart = new Chart(ctx!, {
    type: "line",
    data: {
      labels: props.chartLabels,
      datasets: [
        {
          data: props.chartData,
          backgroundColor: "#e2dfe6",
          fill: true,
          borderColor: "#424242",
          borderWidth: 3,
          tension: 0.3,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          top: 50,
          bottom: 10,
          left: 80,
          right: 12,
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        datalabels: {
          display: true,
          color: "black",
          font: function (context) {
            const width = context.chart.width;
            const size = Math.round(width / 50);

            return {
              weight: "bold",
              size: size,
            };
          },
          align: "end",
          anchor: "end",
          formatter: (value: number, context: any) => {
            const index = context.dataIndex;
            const iconCode =
              props.dadosClima?.forecast?.hourly?.[index]?.weather?.[0]?.icon;
            const emoji = getWeatherEmoji(iconCode);

            return ` ${emoji}\n${value}°C`;
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: "black",
            font: function (context) {
              const width = context.chart.width;
              const size = Math.round(width / 50);

              return {
                weight: "bold",
                size: size,
              };
            },
          },
          grid: {
            display: false,
          },
        },
        y: {
          min: minValue - 1,
          max: maxValue + 1,
          ticks: {
            display: false,
          },
          grid: {
            display: false,
            // drawBorder: false,
          },
          border: {
            display: false,
          },
        },
      },
    },
    plugins: [ChartDataLabels],
  });
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "card-time d-flex flex-column w-100 h-100" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window, {
        modelValue: window.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((window).value = $event)),
        class: "h-100 pa-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { class: "h-100" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _cache[3] || (_cache[3] = _createElementVNode("span", { style: {"font-size":"2.8vh"} }, " Próximas Horas ", -1)),
                (isCanvasReady.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[1] || (_cache[1] = [
                      _createElementVNode("canvas", {
                        style: {"margin":"0px 0 0 -30px"},
                        id: "graficoTempo"
                      }, null, -1)
                    ])))
                  : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_v_progress_circular, { indeterminate: "" }),
                      _cache[2] || (_cache[2] = _createElementVNode("p", {
                        class: "text-center pl-2",
                        style: {"font-size":"2vh"}
                      }, " Carregando previsão... ", -1))
                    ]))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { class: "h-100" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _cache[4] || (_cache[4] = _createElementVNode("span", { style: {"font-size":"2.8vh"} }, " Próximos Dias ", -1)),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dadosClima?.forecast?.daily?.slice(0, 5), (day, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "previsao text-center text-h6",
                      style: _normalizeStyle({
                flex: '1 1 calc(20% - 10px)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                borderRight: index < 4 ? '1px solid #000000' : '',
                padding: '5px',
                color: '#616161',
              })
                    }, [
                      _createElementVNode("p", _hoisted_6, _toDisplayString(getWeatherEmoji(day.weather[0].icon)), 1),
                      _createElementVNode("p", _hoisted_7, _toDisplayString(getNextFiveDays()[index]), 1),
                      _createElementVNode("p", _hoisted_8, _toDisplayString(day.temp.min.toFixed(0)) + "° - " + _toDisplayString(day.temp.max.toFixed(0)) + "° ", 1)
                    ], 4))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})